/**
 * Upload attach-handler bootstrap.
 *
 * Registers the global attach handlers used by `uploadManager.js` so
 * that uploads which were persisted to IndexedDB before a crash /
 * hard reload can be re-attached to their parent entity on restore.
 *
 * Each handler receives:
 *   • rec: { id, filename, content_type, size, kind } — the upload record
 *   • payload: the JSON-serialisable object the caller passed at enqueue
 *
 * All handlers are idempotent — calling them with the same upload id
 * twice is a no-op on the server side (dedup via SHA-256).
 */
import api from "./api";
import { registerAttachHandler, restorePersistedQueue } from "./uploadManager";

let _installed = false;

export function installUploadHandlers() {
  if (_installed) return;
  _installed = true;

  // Job card task photo — most-used field-tech surface.
  registerAttachHandler("jobcard_task_photo", async (rec, payload) => {
    if (!payload?.jc_id || !payload?.task_id) return;
    await api.patch(
      `/jobcards/${payload.jc_id}/checklist/${payload.task_id}`,
      { add_photo_upload_id: rec.id },
    );
  });

  // Job card top-level gallery photo.
  registerAttachHandler("jobcard_gallery_photo", async (rec, payload) => {
    if (!payload?.jc_id) return;
    await api.post(`/jobcards/${payload.jc_id}/photos`, { upload_id: rec.id });
  });

  // Slip scanner (iter 169 — new collection).
  registerAttachHandler("slip_scan", async (rec, payload) => {
    if (!rec?.id) return;
    await api.post(`/slips/from-upload`, {
      upload_id: rec.id,
      note: payload?.note || "",
      kind: payload?.kind || "expense",
    });
  });

  // Kick off the restore cycle once handlers are wired up. Items whose
  // handler isn't registered are left in IDB and ignored.
  restorePersistedQueue().catch((e) => {
    // eslint-disable-next-line no-console
    console.warn("[uploads] restore failed:", e?.message);
  });
}
